import * as Sentry from '@sentry/gatsby';
import { sentryConfigMakeAPayment } from '@agria/utils/src/sentryConfigMakeAPayment';

Sentry.init(sentryConfigMakeAPayment);
